import { Flex, Text } from "@radix-ui/themes";

export interface ActionContainerProps {
    title?: string;
    body?: string;
    children?: React.ReactNode;
}

export default function ActionContainer({ title, body, children }: ActionContainerProps) {
    return (
        <Flex justify="center" align="center" className="h-[calc(100%-64px)] bg-att-light-blue rounded-3xl">
            <Flex justify="center" align="center" direction="column" className="max-w-[416px]">
                {title && (
                    <Text as="p" weight="bold" className="text-2xl text-center mt-10 max-w-[400px]">
                        {title}
                    </Text>
                )}
                {body && (
                    <Text as="p" className="text-base text-center my-6 max-w-[416px]">
                        {body}
                    </Text>
                )}
                {children}
            </Flex>
        </Flex>
    );
}
